import React from 'react';
import Page from "../Page";
import TracingSearch from "./tracing/TracingSearch";
import PageList from "./tracing/PageList";
import LogsList from "./logs/LogsList";
import LogsFilter from "./logs/LogsFilter";

const Logs = () => {
    return (
        <Page>
            <div className="mt-4 w-full inline-table">
                <LogsFilter />
                <LogsList />
            </div>
        </Page>
    );
};

export default Logs;